import { BannerData } from '@wix/dealer-common/dist/src/interfaces';
import { LightboxStorage } from '../services/LightboxStorage';

export interface LightboxTriggers {
  delayOpenSec?: number;
  displayStyle?: string;
  ttlSecSameLB?: number;
  ttlSecAnyLB?: number;
}

export interface LightboxViewerProps {
  translationsUrl: string;
  locale: string;
  dealerOptions?: any;
  onClick?: Function;
  bannerPosition: string;
  metasiteGuid: string;
  signedInstance?: string;
  lightbox: BannerData;
  viewerUrl?: string;
  onView: Function;
  onClose?: Function;
  lightboxStorage: LightboxStorage;
}

export interface LightboxViewerState {
  shouldShow: boolean;
  fadeOut: boolean;
  cmsStoreLoaded: boolean;
  lightboxClosed: boolean;
}

export interface LightboxItem {
  lightboxGuid: string;
  ttlSecSameLB: number;
  ttlSecAnyLB: number;
  lastSeen: number;
}

export const CLOSE_TYPES_BI_EVENT = {
  CLOSE_ESC: 'CLOSE_LB_ESCAPE_PRESS',
  CLOSE_BACKGROUND: 'CLOSE_LB_BACKGROUND',
};
